
const cache = new Map();

const SPRINGBOOT_HOST_MAPPING = {
    'iam-dev.pearson.com': 'https://springboot-dev.identity-nonprd.pearson.com',
    'iam-stage.pearson.com': 'https://springboot-stage.identity-nonprd.pearson.com',
    'iam-ppe.pearson.com': 'https://springboot-ppe.identity-nonprd.pearson.com',
    'iam.pearson.com': 'https://springboot-prod.identity-prd.pearson.com',
    'localhost': 'https://springboot-dev.identity-nonprd.pearson.com'
};

export async function checkIsBannedPwd (value) {
    if (cache.has(value)) {
        return cache.get(value);
    }

    try {
        const url = `${SPRINGBOOT_HOST_MAPPING[location.hostname] || SPRINGBOOT_HOST_MAPPING['iam.pearson.com']}/v1/identity/password/checkDictionary`;
        const formData = new FormData();

        formData.append('password', value);

        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        cache.set(value, data);
        return data;
    } catch (error) {
        return error;
    }
}
